import { HiHome } from 'react-icons/hi';
import { GrMail } from 'react-icons/gr';
import { RiKey2Fill } from 'react-icons/ri';
import { GiNotebook } from 'react-icons/gi';
import { BsFillFileEarmarkArrowUpFill, BsFillPersonFill, BsPersonPlusFill } from 'react-icons/bs';
import { MemberTypeEnum } from 'src/model';
import { IMenu } from 'src/component/Layout/types';

export const useMenuList = () => {
    const menu: IMenu[] = [
        {
            logo: <HiHome size={22} />,
            label: "Home",
            link: "home",
            screen: [MemberTypeEnum.ADMIN, MemberTypeEnum.STUDENT, MemberTypeEnum.TEACHER],
        },
        {
            logo: <BsFillPersonFill size={22} />,
            label: "User Profiles",
            link: "profile",
            screen: [MemberTypeEnum.ADMIN, MemberTypeEnum.STUDENT, MemberTypeEnum.TEACHER],

        },
        {
            logo: <BsPersonPlusFill size={22} />,
            label: "Add User",
            link: "add-user",
            screen: [MemberTypeEnum.ADMIN],

        },
        {
            logo: <GiNotebook size={22} />,
            label: "View Results",
            link: "view-results",
            screen: [MemberTypeEnum.ADMIN, MemberTypeEnum.STUDENT, MemberTypeEnum.TEACHER],

        },
        {
            logo: <GrMail size={22} />,
            label: "Broadcast Mail",
            link: "broadcast-mail",
            screen: [MemberTypeEnum.ADMIN],

        },
        {
            logo: <BsFillFileEarmarkArrowUpFill size={22} />,
            label: "Upload Results",
            link: "upload-results",
            screen: [MemberTypeEnum.TEACHER],

        },
        {
            logo: <RiKey2Fill size={22} />,
            label: "Reset Password",
            link: "reset-password",
            screen: [MemberTypeEnum.ADMIN, MemberTypeEnum.STUDENT, MemberTypeEnum.TEACHER],
        },
    ]

    return {
        menu
    }
}
